import {Component, Input} from '@angular/core';
import {ClaimItem, ObjectType} from '../../entity/claim-item';
import {ClaimMetadataRequest} from '../../entity/metadata';
import {RouterLink} from '@angular/router';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';

@Component({
  selector: 'app-submitted-claim-overview',
  imports: [
    RouterLink,
    LocalizationPipePipe
  ],
  templateUrl: './submitted-claim-overview.html',
  styleUrl: './submitted-claim-overview.scss'
})
export class SubmittedClaimOverview {
  @Input() claimId!: string | undefined;
  @Input() claimMetadata!: ClaimMetadataRequest | ClaimItem | undefined;
  @Input() objectType!: ObjectType;

  createNewClaim() {
    const hints = new URLSearchParams({
      'insuranceClaimReference': this.claimMetadata?.insuranceClaimReference ?? '',
      'condominiumName': this.claimMetadata?.condominiumName ?? '',
      'lossAdjusterClaimReference': this.claimMetadata?.lossAdjusterClaimReference ?? '',
      'address': this.claimMetadata?.address ?? '',
    })
    window.location.href = `/claim/create/${this.objectType.toString()}?${hints.toString()}`
  }
}
